import { Collapse, IconButton, ListItem, ListItemAvatar, Typography } from '@material-ui/core'
import React from 'react'
import { AiOutlineArrowRight } from 'react-icons/ai'
import { NavLink, useHistory } from 'react-router-dom'

export default function CustomCollapse({ open, collapseData = [], classes }) {
  // console.log({ open, collapseData })
  const history = useHistory()
  return (
    <>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {collapseData.map((item, index) => (
          <ListItem
            button
            onClick={() => history.push(item.url)}
            key={index}
            style={{ marginBottom: '14px', marginLeft: '40px' }}
            className={window.location.pathname === item.url ? `${classes.selected}` : ''}
          >
            <AiOutlineArrowRight style={{ fontSize: '1.3rem', marginRight: '5px' }} />

            <Typography style={{ lineHeight: '20px', fontSize: '14px' }}>{item.label} </Typography>
          </ListItem>
        ))}
      </Collapse>
    </>
  )
}
